import { InviteStatusEnum } from './enums/InviteStatus';
export class InviteCreation {
    organizationCode: string;
    organizationName: string;
    email: string;
    role: string;
    firstName: string;
    lastName: string;
    fileNumber: string;
    parentOrganizationId: number;
    isEmployee: boolean;
    isMainCompanyEmployee: boolean;
    associatedOrganizationId: number;
    systemAccountIdSintra: string;
    statusSystemAccountIdSintra: boolean;
    status: InviteStatusEnum;
    isPatient: boolean;
    inviteId: number;
    currentStatus: string;
}